import { render, staticRenderFns } from "./EducationalStandardsMenu.vue?vue&type=template&id=374e5812&scoped=true&lang=pug&"
import script from "./EducationalStandardsMenu.vue?vue&type=script&lang=ts&"
export * from "./EducationalStandardsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./EducationalStandardsMenu.vue?vue&type=style&index=0&id=374e5812&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e5812",
  null
  
)

export default component.exports